var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:_vm.modify,attrs:{"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M2.9165 7H11.0832","stroke":_vm.fill,"stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }